export default "__VITE_ASSET__DwQUEPNy__"